const getters = {
  role: (state) => state.permission.role,
  menus: (state) => state.permission.menus,
  allMenusList: (state) => state.permission.allMenusList,
  allMenusTree: (state) => state.permission.allMenusTree,
  activeMenu: (state) => state.permission.activeMenu,
  activeMenuTree: (state) => state.permission.activeMenuTree,
  activeMenuChildren: (state) => state.permission.activeMenuChildren,
  site: (state) => state.permission.siteInfo,
  members: (state) => state.member.members,
  activeMenuId: (state) => state.permission.activeMenu.id,
  curDetailTitle: (state) => state.permission.curDetailTitle,
};

export default getters;
